import Model from "~/models/_Model";

export default class Message extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/courseplanner";
  }

  // Set the resource route of the model
  resource() {
    return "messages";
  }

  relations() {
    return {};
  }

  // Computed Attributes
}
